






























































import Button from "@/shared/components/ui/Button.vue";
import { Vue, Component, Prop } from "@/shared/vuepack";
import { Validator } from "vee-validate";
import { PartnerCreateEmployerEvent } from "@/shared/types";
import { usePartnerStore } from "@/employer/store/partner";

@Component({
  components: {
    Button
  }
})
export default class PartnerCreateEmployer extends Vue {

  partnerStore = usePartnerStore();

  @Prop({ required: true })
  partnerId: number;

  $validator: Validator;
  companyName = "";
  externalEmployerId = "";
  firstName = "";
  lastName = "";
  email = "";
  inProcess = false;
  hideForm = false;
  createOwner = true;
  externalEmployerIdError = "";

  get externalEmployerIdHasError () {
    return this.externalEmployerIdError !== "";
  }

  get isSubmitDisabled () {
    return this.$validator.errors.any();
  }

  submit () {
    if (this.inProcess) {
      return;
    }

    this.$validator.validateAll().then(result => {
      if (!result) {
        return;
      }
      this.inProcess = true;
      return this.partnerStore.postPartnerCreateEmployer({
        partnerId: this.partnerId,
        companyName: this.companyName,
        externalEmployerId: this.externalEmployerId
      }
      ).then((resp: any) => {
        this.companyName = "";
        this.hideForm = true;

        let eventPayload: PartnerCreateEmployerEvent = {
          employerId: resp.data.employerId
        };

        if (this.createOwner) {
          eventPayload = {
            ...eventPayload,
            initialUser: {
              firstName: this.firstName,
              lastName: this.lastName,
              email: this.email
            }
          };
        }
        this.$emit("complete", eventPayload);
      }).catch(error => {
        this.externalEmployerIdError = error;
      }).finally(() => {
        this.inProcess = false;
      });
    });
  }
}
